import { Button } from "Components/Button";
import { useQueryClient } from "react-query";
import { MonthsOptionsStyle } from "./styles";

interface MonthsOptionsProps {
  selectedMonth: string;
  setRequestMonth: (date: string) => void;
  blockedClick: boolean;
  setAppointmentInfo: (data: any) => void;
  additionalMonths?: number;
}

const allMonths = [
  { label: "Janeiro", value: 1 },
  { label: "Fevereiro", value: 2 },
  { label: "Março", value: 3 },
  { label: "Abril", value: 4 },
  { label: "Maio", value: 5 },
  { label: "Junho", value: 6 },
  { label: "Julho", value: 7 },
  { label: "Agosto", value: 8 },
  { label: "Setembro", value: 9 },
  { label: "Outubro", value: 10 },
  { label: "Novembro", value: 11 },
  { label: "Dezembro", value: 12 },
];

export const MonthsOptions = ({
  selectedMonth,
  setRequestMonth,
  blockedClick,
  setAppointmentInfo,
  additionalMonths = 2,
}: MonthsOptionsProps) => {
  const client = useQueryClient();

  const initialDate = new Date();
  const currentMonthIndex = initialDate.getMonth();

  const currentYear = initialDate.getFullYear();

  const availableMonths = Array.from(
    { length: additionalMonths + 1 },
    (_, i) => {
      const monthIndex = (currentMonthIndex + i) % 12;
      const yearOffset = Math.floor((currentMonthIndex + i) / 12);
      return {
        ...allMonths[monthIndex],
        year: currentYear + yearOffset,
      };
    }
  );

  const [selectedYear, selectedMonthNumber] = selectedMonth
    .split("-")
    .map(Number);

  const onSelectMonth = (optionMonth: number, optionYear: number) => {
    setAppointmentInfo({ query_hour: "" });
    setAppointmentInfo({ query_date: "" });
    client.removeQueries({ queryKey: ["hours"] });

    const formattedMonth = optionMonth.toString().padStart(2, "0");
    setRequestMonth(`${optionYear}-${formattedMonth}`);
  };

  return (
    <MonthsOptionsStyle>
      {availableMonths.map((t) => (
        <Button
          key={`${t.value}-${t.year}`}
          onClick={() => onSelectMonth(t.value, t.year)}
          {...(selectedMonthNumber === t.value && selectedYear === t.year
            ? null
            : { outlined: true })}
          disabled={blockedClick}
        >
          {t.label}
        </Button>
      ))}
    </MonthsOptionsStyle>
  );
};
